import { advantagesData } from "../../config/homePageUtils";
import Image from "../common/Image";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const AdvantageSection = ({ data = advantagesData }) => {
  const { language } = useLanguage();
  return (
    <section
      className="bg-white py-8 sm:py-20 md:py-16 advantage-sector"
      id="advantage-section"
    >
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-bold text-3xl sm:text-4xl mb-4 section-heading text-center text-black">
          {language ? data.title.hi : data.title.en}{" "}
          <span className="text-[#018f9b] font-bold section-heading">
            {language ? data.highlight.hi : data.highlight.en}
          </span>
          <div className="w-24 h-1 bg-[#018f9b] mx-auto mt-2"></div>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-14 mt-12">
          {data.cards.map((card, idx) => (
            <div
              key={idx}
              className={`text-white rounded-xl p-6 relative shadow-lg hover:scale-105 transition-transform duration-300 ${card.bgClass}`}
            >
              <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-white p-4 rounded-full shadow-md">
                <Image
                  src={card.icon}
                  alt={`${language ? card.title.hi : card.title.en} Icon`}
                  className="w-10 h-10"
                />
              </div>

              <h3 className="text-xl font-semibold text-white mt-10 mb-4">
                {language ? card.title.hi : card.title.en}
              </h3>

              <ul className="text-left space-y-3 text-sm">
                {card.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-white text-lg">✔</span>
                    <span className="text-white">
                      {language ? point.hi : point.en}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantageSection;
